import { validateNumber } from 'ember-changeset-validations/validators';
import { validateIsSameOrAfter } from 'uplisting-frontend/validators/is-same-or-after';
import { validateIsSameOrBefore } from 'uplisting-frontend/validators/is-same-or-before';

const dayRateValidation = validateNumber({
  gte: 0,
  integer: true,
  allowBlank: true,
});

export const BulkRateValidation = {
  sunday: dayRateValidation,
  monday: dayRateValidation,
  tuesday: dayRateValidation,
  wednesday: dayRateValidation,
  thursday: dayRateValidation,
  friday: dayRateValidation,
  saturday: dayRateValidation,

  from: validateIsSameOrBefore('to'),
  to: validateIsSameOrAfter('from'),
};
